import { render, staticRenderFns } from "./HandwriteInput.vue?vue&type=template&id=95a34334"
import script from "./HandwriteInput.vue?vue&type=script&lang=js"
export * from "./HandwriteInput.vue?vue&type=script&lang=js"
import style0 from "./HandwriteInput.vue?vue&type=style&index=0&id=95a34334&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports